var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 48097743"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.6667 8.84961C35.5507 8.84961 36.3986 9.2008 37.0237 9.82592C37.6488 10.451 38 11.2989 38 12.1829V35.5163C38 36.4003 37.6488 37.2482 37.0237 37.8733C36.3986 38.4984 35.5507 38.8496 34.6667 38.8496H11.3333C10.4493 38.8496 9.60143 38.4984 8.97631 37.8733C8.35119 37.2482 8 36.4003 8 35.5163V12.1829C8 11.2989 8.35119 10.451 8.97631 9.82592C9.60143 9.2008 10.4493 8.84961 11.3333 8.84961H34.6667ZM33.8333 34.6829V25.8496C33.8333 24.4086 33.2609 23.0266 32.2419 22.0077C31.223 20.9887 29.841 20.4163 28.4 20.4163C26.9833 20.4163 25.3333 21.2829 24.5333 22.5829V20.7329H19.8833V34.6829H24.5333V26.4663C24.5333 25.1829 25.5667 24.1329 26.85 24.1329C27.4688 24.1329 28.0623 24.3788 28.4999 24.8164C28.9375 25.2539 29.1833 25.8474 29.1833 26.4663V34.6829H33.8333ZM14.4667 18.1163C15.2093 18.1163 15.9215 17.8213 16.4466 17.2962C16.9717 16.7711 17.2667 16.0589 17.2667 15.3163C17.2667 13.7663 16.0167 12.4996 14.4667 12.4996C13.7196 12.4996 13.0032 12.7964 12.475 13.3246C11.9468 13.8528 11.65 14.5692 11.65 15.3163C11.65 16.8663 12.9167 18.1163 14.4667 18.1163ZM16.7833 34.6829V20.7329H12.1667V34.6829H16.7833Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3ed4ff9c6a6c532de4b2b0055fb3983d.svg";
export { ForwardRef as ReactComponent };